import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.containerTargets.forEach(container => {
      container.addEventListener('dragstart', this.handleDragStart.bind(this));
      container.addEventListener('dragover', this.handleDragOver.bind(this));
      container.addEventListener('dragend', this.handleDragEnd.bind(this));
    });
    this.updatePositions();
  }

  add(event) {
    const containerName = event.target.closest('button')?.dataset?.container;
    if (!containerName) {
      return;
    }

    const container = this.element.querySelector(`[data-container-name="${containerName}"]`);
    const template = this.element.querySelector(`[data-nested-form-drag-target="${containerName}Template"]`);
    if (!container || !template) return;

    container.insertAdjacentHTML("beforeend", template.innerHTML.replace(/NEW_RECORD/g, new Date().getTime()));
    this.updatePositions();
  }

  remove(event) {
    const item = event.target.closest("[data-nested-form-drag-target='item']");
    const destroyField = item.querySelector("[data-destroy-field]");

    if (destroyField) {
      destroyField.value = true;
      item.style.display = "none";
    } else {
      item.remove();
    }
    this.updatePositions();
  }

  updatePositions() {
    this.containerTargets.forEach(container => {
      let position = 1;
      container.querySelectorAll("[data-nested-form-drag-target='item']").forEach(item => {
        const isDestroyed = item.style.display == "none";
        if (!isDestroyed) {
          const positionField = item.querySelector("[data-position-field]");
          if (positionField) positionField.value = position++;
        }
      })
    })
  }

  handleDragStart(e) {
    const item = e.target.closest("[data-nested-form-drag-target='item']");
    if (!item) {
      return;
    }
    this.draggedItem = item;
    item.classList.add('opacity-50');
  }

  handleDragOver(e) {
    e.preventDefault();

    const target = e.target.closest("[data-nested-form-drag-target='item']");
    if (!target || target === this.draggedItem) {
      return;
    }

    const rect = target.getBoundingClientRect();
    const midY = rect.top + rect.height / 2;
    // Insert before if the cursor is above the middle of the target
    const insertBefore = e.clientY < midY ? target : target.nextElementSibling;

    e.currentTarget.insertBefore(this.draggedItem, insertBefore);
  }

  handleDragEnd() {
    if (this.draggedItem) {
      this.draggedItem.classList.remove('opacity-50');
      this.draggedItem = null;
    }
    this.updatePositions();
  }
}
